var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6, _circle7, _circle8, _circle9, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBusinessComplianceIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 101,
    viewBox: "0 0 86 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 50.0002,
    r: 28,
    fill: "#F3F6FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8664,
    cy: 13.5248,
    r: 2.55,
    fill: "#D9DBEA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.4613,
    cy: 14.669,
    r: 1.14486,
    fill: "#D9DBEA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.389,
    cy: 32.6817,
    r: 1.14486,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.0039,
    cy: 44.8848,
    r: 1.48832,
    fill: "#C4C4C4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.30472,
    cy: 9.48588,
    r: 1.48832,
    fill: "#D9DBEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5904 2.85361L48.9603 1.48372L49.9507 2.47414L48.5808 3.84403L50.1291 5.39227L49.0855 6.43581L47.5373 4.88757L46.1636 6.26126L45.1732 5.27084L46.5469 3.89716L45.0631 2.41343L46.1067 1.36988L47.5904 2.85361Z",
    fill: "#D8D9E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7185 16.56L12.8213 15.4572L13.6186 16.2545L12.5158 17.3573L13.7622 18.6037L12.9221 19.4438L11.6758 18.1974L10.5699 19.3033L9.77257 18.506L10.8784 17.4001L9.68398 16.2057L10.5241 15.3656L11.7185 16.56Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14582 39.464L4.84861 38.7612L5.35672 39.2693L4.65394 39.9721L5.44822 40.7664L4.91286 41.3017L4.11857 40.5074L3.41383 41.2122L2.90572 40.7041L3.61046 39.9993L2.84927 39.2381L3.38463 38.7028L4.14582 39.464Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0638 28.377L72.7666 27.6743L73.2747 28.1824L72.5719 28.8852L73.3662 29.6794L72.8308 30.2148L72.0365 29.4205L71.3318 30.1253L70.8237 29.6171L71.5284 28.9124L70.7672 28.1512L71.3026 27.6159L72.0638 28.377Z",
    fill: "#E6E6E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8779 49.3828L80.0636 100.641L24.8343 86.7631L38.7109 36.3541L84.8779 49.3828Z",
    fill: "#D9DBEA",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8994 48.8857L35.9346 36.2866C33.5484 39.7227 27.4016 48.5994 21.9038 56.617C16.406 64.6346 6.82301 74.4658 2.71875 78.3791L59.9875 95.2734C61.0374 94.7007 65.4853 90.5201 74.8773 78.3791C84.2694 66.2382 85.4721 53.6581 84.8994 48.8857Z",
    fill: "white",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2302,
    cy: 49.7449,
    r: 2.00441,
    fill: "#D9DBEA",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3591,
    cy: 61.7712,
    r: 2.00441,
    fill: "#D9DBEA",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4861,
    cy: 72.6521,
    r: 2.00441,
    fill: "#D9DBEA",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.4103,
    y: 64.1005,
    width: 26.9163,
    height: 0.572687,
    rx: 0.286344,
    transform: "rotate(15.5 39.4103 64.1005)",
    fill: "#C4C4C4",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4143,
    y: 75.7062,
    width: 24.3087,
    height: 0.572687,
    rx: 0.286344,
    transform: "rotate(15.5 33.4143 75.7062)",
    fill: "#C4C4C4",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.9614,
    y: 51.8377,
    width: 26.9163,
    height: 0.572687,
    rx: 0.286344,
    transform: "rotate(14.5 46.9614 51.8377)",
    fill: "#C4C4C4",
    stroke: "#D9DBEA",
    strokeWidth: 0.572687
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBusinessComplianceIllustration);
export default __webpack_public_path__ + "static/media/empty-business-compliance-illustration.af5dc832503f9cafe1517b7fe1051c95.svg";
export { ForwardRef as ReactComponent };